export const NEW = 'New';
export const APPROVED = 'Approved';
export const REJECTED = 'Rejected';
export const CANCELLED = 'Cancelled';